import React, {Component} from 'react';
import HeaderAccessItem from './HeaderAccessItem.js';

class HeaderAccess extends Component {
    render() {
        const { setFontSize, cfont, setContrast, contrast, setOpened, openedElem } = this.props;

        return (
            <div className="header__access">
                <HeaderAccessItem type="font" setOpened={setOpened} currentOpened={openedElem}
                                  setFontSize={setFontSize} cfont={cfont}/>
                <HeaderAccessItem type="contrast" setOpened={setOpened}  currentOpened={openedElem}
                                  setContrast={setContrast} contrast={contrast}/>
            </div>
        );
    };
};

export default HeaderAccess;



// WEBPACK FOOTER //
// ./src/components/header/HeaderAccess.js